import styled from 'styled-components';

export const StyledSharePopover = styled.div<{ isError: boolean }>`
  background: #ffffff;
  box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.16);
  border-radius: 4px;
  width: 400px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .share-header {
    padding: 12px;
    display: flex;
    align-items: baseline;
    border-bottom: 1px solid #e6e6e6;
  }

  .email-dropdown-label {
    color: #12344d;
    opacity: 0.5;
  }

  .share-multiselect {
    flex-grow: 1;
  }

  .share-buttons {
    padding: 12px;
    display: flex;
    border-top: 1px solid #e6e6e6;
    .spacer {
      flex-grow: 1;
    }
  }

  .share-content {
    flex-grow: 1;
    padding: 12px;
  }

  div[id='dropdownField container'] {
    ${({ isError }) => (isError ? '' : 'border-color:transparent')}
  }

  .share-textarea {
    box-shadow: none !important;
    border: none !important;
  }
`;
